import { baseUrl } from "./Config/config";

const ABSOLUTE_URL_PATTERN = /^(?:[a-z]+:)?\/\//i;

export const resolveAssetUrl = (value?: string | null): string => {
  const trimmedValue = value?.trim();
  if (!trimmedValue) {
    return "";
  }

  if (
    ABSOLUTE_URL_PATTERN.test(trimmedValue) ||
    trimmedValue.startsWith("data:") ||
    trimmedValue.startsWith("blob:")
  ) {
    return trimmedValue;
  }

  const normalizedBaseUrl = (baseUrl || "").replace(/\/+$/, "");
  if (!normalizedBaseUrl) {
    return trimmedValue;
  }

  const normalizedPath = trimmedValue.startsWith("/")
    ? trimmedValue
    : `/${trimmedValue}`;

  return `${normalizedBaseUrl}${normalizedPath}`;
};

export const appendCacheBuster = (
  value: string | null | undefined,
  token?: string | number
): string => {
  const resolvedUrl = resolveAssetUrl(value);
  if (!resolvedUrl || token === undefined || token === null || token === "") {
    return resolvedUrl;
  }

  const separator = resolvedUrl.includes("?") ? "&" : "?";
  return `${resolvedUrl}${separator}t=${token}`;
};
